/* Waco Diamonds - PDP metal-colour image switch (resolution-safe).
   A combined-listing ring PDP shows the PARENT product's media. The parent carries per-colour images
   whose alt text contains the colour name ("Yellow Gold ...", "Rose Gold ...", "White Gold ..."). The
   merged variants carry featured_media=null, so the native gallery never switches on a Metal Color
   change. This shows only the selected colour's images (thumbnails + main) and activates the first,
   purely client-side.

   IMPORTANT: this must NEVER read other products via `all_products` at render time - doing so during
   the combined-listing parent's section render resets the resolved variant to the colour default and
   freezes the picker. This script only reads media ALREADY in the DOM and drives the native gallery
   via its public changeImage() API, so it cannot affect variant resolution. */
(function () {
  "use strict";
  if (window.__wacoPdpColorImage) return;
  window.__wacoPdpColorImage = true;

  var COLORS = ["Yellow Gold", "Rose Gold", "White Gold"];

  function selectedColor() {
    var c = document.querySelector('input.waco-radio[data-option-name="Metal Color"]:checked');
    return c ? c.value : null;
  }

  // Determine a gallery item's colour from its image alt text (parent media is colour-tagged).
  // Use "contains", NOT "startsWith": the MAIN slide alt is "Yellow Gold ..." but the THUMBNAIL img
  // alt is prefixed "Load image N in gallery view. Yellow Gold ...", so only a contains-match hits both.
  function itemColor(el) {
    var img = el.querySelector("img[alt]");
    var alt = img ? (img.getAttribute("alt") || "") : "";
    for (var i = 0; i < COLORS.length; i++) {
      if (alt.indexOf(COLORS[i]) !== -1) return COLORS[i];
    }
    return null;
  }

  function galleryItems() {
    // Thumbnails: <li.pdp-thumbnails__item> (media id on an inner <button data-thumbnail>, NOT the li).
    // Main slides: <div.pdp-thumbnails__main data-media-id>. Slideshow (non-thumbnail): .slideshow__slide.
    return document.querySelectorAll(
      ".pdp-thumbnails__item, .pdp-thumbnails__main[data-media-id], .slideshow__slide[data-media-id]"
    );
  }

  function apply() {
    var gallery = document.querySelector("media-gallery");
    if (!gallery) return;
    var color = selectedColor();
    var items = galleryItems();
    if (!items.length) return;

    // Only act when the media is actually colour-tagged (i.e. a per-colour parent). If none of the
    // items map to a colour, leave the gallery untouched (regular product / unexpected markup).
    var anyTagged = false;
    for (var i = 0; i < items.length; i++) { if (itemColor(items[i])) { anyTagged = true; break; } }
    if (!anyTagged) return;

    var firstMainId = null;
    items.forEach(function (el) {
      var c = itemColor(el);
      var on = !c || !color || c === color; // untagged items stay visible; tagged filter by colour
      el.classList.toggle("waco-color-hide", !on);
      if (on && c === color && firstMainId === null &&
          (el.classList.contains("pdp-thumbnails__main") || el.classList.contains("slideshow__slide"))) {
        firstMainId = el.getAttribute("data-media-id");
      }
    });
    if (firstMainId && typeof gallery.changeImage === "function") gallery.changeImage(firstMainId);
  }

  function injectStyle() {
    if (document.getElementById("waco-color-image-style")) return;
    var st = document.createElement("style");
    st.id = "waco-color-image-style";
    st.textContent = ".pdp-thumbnails__item.waco-color-hide,.pdp-thumbnails__main.waco-color-hide,.slideshow__slide.waco-color-hide{display:none !important;}";
    document.head.appendChild(st);
  }

  function init() {
    injectStyle();
    // Radios are replaced when the native section-render swaps the <variant-picker>, so delegate.
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input.waco-radio[data-option-name="Metal Color"]')) apply();
    });
    document.addEventListener("variant:change", apply);

    var tries = 0;
    (function ready() {
      var g = document.querySelector("media-gallery");
      if (g && typeof g.changeImage === "function") { apply(); return; }
      if (tries++ > 12) { apply(); return; }
      requestAnimationFrame(ready);
    })();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
